import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import MainRoutes from './components/routing/Routes';
import './styles/main.scss';
import Loading from './components/loading/Loading';
import loadingSelector from './reducers/api/selectors';
import { BrowserRouter } from 'react-router-dom';
import Notifications from './components/notifications/Notifications';
import KeyboardShortcutsDialog from './components/keyboard/KeyboardShortcutsDialog';
import { OPEN_KEYBOARD_SHORTCUTS_EVENT } from './components/keyboard/events';
import { useKeyboardShortcut } from './hooks/useKeyboardShortcut';

function App() {
  require(`./styles/${process.env.REACT_APP_THEME_CLASS_STYLE}.scss`);
  const loading = useSelector(loadingSelector);
  const [showShortcuts, setShowShortcuts] = useState(false);

  const openShortcuts = useCallback(() => setShowShortcuts(true), []);
  const closeShortcuts = useCallback(() => setShowShortcuts(false), []);

  // `?` global shortcut: open the help dialog from anywhere in the app.
  useKeyboardShortcut({ key: '?', handler: openShortcuts });

  // Other components (ProfileMenu) dispatch a CustomEvent to open the dialog.
  useEffect(() => {
    const handler = () => openShortcuts();
    window.addEventListener(OPEN_KEYBOARD_SHORTCUTS_EVENT, handler);
    return () => window.removeEventListener(OPEN_KEYBOARD_SHORTCUTS_EVENT, handler);
  }, [openShortcuts]);

  return (
    <div className={`${process.env.REACT_APP_THEME_CLASS_STYLE}`} style={{ width: '100%' }}>
      <BrowserRouter>
        {loading && <Loading />}
        <Notifications />
        <MainRoutes />
        {showShortcuts && <KeyboardShortcutsDialog onClose={closeShortcuts} />}
      </BrowserRouter>
    </div>
  );
}

export default App;
